const KEY_MAP: [string, string][] = [
  ['shishbesh_tokens', 'sheshdash_tokens'],
  ['shishbesh_last_join', 'sheshdash_last_join'],
  ['shishbesh_announcement_version', 'sheshdash_announcement_version'],
];

export function migrateLocalStorage(): void {
  for (const [oldKey, newKey] of KEY_MAP) {
    const oldVal = localStorage.getItem(oldKey);
    if (oldVal !== null && localStorage.getItem(newKey) === null) {
      localStorage.setItem(newKey, oldVal);
    }
    if (oldVal !== null) {
      localStorage.removeItem(oldKey);
    }
  }
}
